import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import qs from 'query-string';
import Claims from './Claims';
import Account from './General/Account';
import ChangePassword from './General/ChangePassword';
import SEV from './TroubleTicketing/SEV';
import Incidents from './TroubleTicketing/Incidents';
import Actions from './TroubleTicketing/Actions';
import BirthdayPoints from './Rewards/BirthdayPoints';
import Reasons from './Rewards/Reasons';
import Reminder from './SmartScheduler/Reminder';
import FAQ from './FAQ/FAQ';
import { newFetch, GET, DELETE } from '../../../helpers/fetch';

const Setting = ({ history, location: { search } }) => {
  const params = qs.parse(search);
  const type = localStorage.getItem('type');
  const user = JSON.parse(localStorage.getItem('user'));
  const clientID = parseInt(localStorage.getItem('client'), 10);
  const [clients, setClients] = useState([]);

  const tabs =
    type === 'superadmin' || type === 'admin'
      ? [
          {
            name: 'General',
            settings: '',
            menus: [
              {
                name: 'Account',
                component: <Account />,
              },
              {
                name: 'Change Password',
                component: <ChangePassword />,
              },
            ],
          },
          {
            name: 'Trouble Ticketing',
            settings: 'enable_trouble_ticketing',
            menus: [
              {
                name: 'SEV',
                component: <SEV />,
              },
              {
                name: 'Incidents',
                component: <Incidents />,
              },
              {
                name: 'Actions',
                component: <Actions />,
              },
            ],
          },
          {
            name: 'Rewards',
            settings: 'enable_reward',
            menus: [
              {
                name: 'Birthday Points',
                component: <BirthdayPoints />,
              },
              {
                name: 'Reasons',
                component: <Reasons />,
              },
            ],
          },
          {
            name: 'Claims',
            settings: 'enable_claims',
            menus: [
              {
                name: 'Types',
                component: <Claims />,
              },
            ],
          },
        ]
      : [
          {
            name: 'General',
            menus: [
              {
                name: 'Account',
                component: <Account />,
              },
              {
                name: 'Change Password',
                component: <ChangePassword />,
              },
            ],
          },
        ];

  const [activeTab, setActiveTab] = useState(
    params.tab && tabs.find((tab) => tab.name === params.tab)
      ? tabs.find((tab) => tab.name === params.tab)
      : tabs[0]
  );

  const [activeMenu, setActiveMenu] = useState(
    params.tab &&
      params.menu &&
      tabs
        .find((tab) => tab.name === params.tab)
        .menus.find((menu) => menu.name === params.menu)
      ? tabs
          .find((tab) => tab.name === params.tab)
          .menus.find((menu) => menu.name === params.menu)
      : tabs[0].menus[0]
  );

  const fetchClients = async () => {
    let api_path = `/client/${clientID}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setClients(response.data);
    }
  };

  const handleChangeTab = (tab) => {
    setActiveTab(tab);
    setActiveMenu(tab.menus[0]);

    history.push({
      pathname: `/setting`,
      search: qs.stringify({
        ...params,
        menu: tab.menus[0].name,
        tab: tab.name,
      }),
    });
  };

  const handleChangeMenu = (menu) => {
    setActiveMenu(menu);

    history.push({
      pathname: `/setting`,
      search: qs.stringify({
        ...params,
        menu: menu.name,
        tab: activeTab.name,
      }),
    });
  };

  useEffect(() => {
    setActiveTab(tabs[0]);
    setActiveMenu(tabs[0].menus[0]);
    fetchClients();
  }, [clientID]);

  return (
    <div
      className="container-fluid"
      style={{ paddingLeft: '2rem', paddingRight: '2rem' }}
    >
      <div className="border-bottom pb-2 py-2 d-flex align-items-center">
        <h6 className="flex-grow-1 pt-4" style={{ color: '#5156BE' }}>
          Settings
        </h6>
      </div>
      <div className="d-flex align-items-start">
        <div
          className="d-flex flex-column flex-grow-1"
          style={{ marginTop: '2rem', marginBottom: '2rem' }}
        >
          <div
            className="d-flex justify-content-start"
            style={{ minWidth: 0, maxWidth: '100vw', overflowX: 'auto' }}
          >
            {tabs.map(
              (tab, index) =>
                ((clients && clients[`${tab.settings}`]) || !tab.settings) && (
                  <div
                    key={index}
                    className="pb-3 flex-shrink-0"
                    onClick={() => handleChangeTab(tab)}
                  >
                    <div
                      style={
                        activeTab.name === tab.name
                          ? {
                              cursor: 'pointer',
                              marginRight: '1.5rem',
                              paddingBottom: '1rem',
                              marginBottom: '1rem',
                              borderBottom: '5px #5156BE solid',
                            }
                          : {
                              cursor: 'pointer',
                              marginRight: '1.5rem',
                              paddingBottom: '1rem',
                              marginBottom: '1rem',
                            }
                      }
                    >
                      <span
                        className={
                          activeTab.name === tab.name
                            ? 'text-brand'
                            : 'text-muted'
                        }
                      >
                        {tab.name}
                      </span>
                    </div>
                  </div>
                )
            )}
          </div>
          {tabs.map(
            (tab) =>
              tab.name === activeTab.name &&
              ((clients && clients[`${tab.settings}`]) || !tab.settings) && (
                <div key={tab.name} className="rounded d-flex adjust-shadow">
                  <div
                    style={{
                      width: '15rem',
                      backgroundColor: '#5e5e5e',
                    }}
                    className="border-right"
                  >
                    {activeTab.menus.map((menu) => (
                      <div
                        key={menu.name}
                        className={`p-4 ${
                          activeMenu === menu
                            ? ` bg-brand fw-semibold`
                            : `text-white`
                        }`}
                        onClick={() => handleChangeMenu(menu)}
                        style={{ cursor: 'pointer' }}
                      >
                        {menu.name}
                      </div>
                    ))}
                  </div>
                  <div className="flex-grow-1 bg-white">
                    {activeMenu.component}
                  </div>
                </div>
              )
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter(Setting);
